import Button from 'components/Button';
import Error from 'components/form/Error';
import ActionModal from 'components/Modal/ActionModal';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import privateAPI from 'utils/privateAxiosInstance';

const Container = styled.div`
  margin-top: 3rem;
  margin-bottom: 1rem;
`;

type Props = {
  id: number;
  redirect: string;
};
const DeleteUser: FC<Props> = ({ id, redirect }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const navigate = useNavigate();

  const handleDelete = () => {
    setLoading(true);
    setError(false);

    privateAPI
      .delete(`/user/${id}`)
      .then(() => {
        navigate(redirect);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <ActionModal
        title="Supprimer un utilisateur"
        open={open}
        close={() => setOpen(false)}
        applyText="Supprimer définitivement"
        apply={handleDelete}
        loading={loading}
        color="error"
      >
        {error && <Error>Une erreur est survenue.</Error>}
        <p>
          Vous êtes sur le point de supprimer définitivement le profil d'un
          utilisateur.
        </p>
        <p>
          Cette action est irreversible et supprimera toutes les données
          concernant cet utilisateur à travers toute l'application.
        </p>
        <p>Souhaitez-vous continuer ?</p>
      </ActionModal>
      <Container>
        <Button
          variant="outlined"
          color="error"
          type="button"
          onClick={() => setOpen(true)}
        >
          Supprimer l'utilisateur
        </Button>
      </Container>
    </>
  );
};

export default DeleteUser;
